import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import ProtectedRoute from '../components/admin/ProtectedRoute';
import AdminLayout from '../components/admin/AdminLayout';

const Home = lazy(() => import('../pages/home/page'));
const About = lazy(() => import('../pages/about/page'));
const Articles = lazy(() => import('../pages/articles/page'));
const ArticleDetail = lazy(() => import('../pages/articles/detail/page'));
const Notes = lazy(() => import('../pages/notes/page'));
const NoteDetail = lazy(() => import('../pages/notes/detail/page'));
const Portfolio = lazy(() => import('../pages/portfolio/page'));
const Progress = lazy(() => import('../pages/progress/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

// Admin pages
const AdminLogin = lazy(() => import('../pages/admin/login/page'));
const AdminRegister = lazy(() => import('../pages/admin/register/page'));
const AdminDashboard = lazy(() => import('../pages/admin/dashboard/page'));

import AdminDashboardPage from '../pages/admin/dashboard/page';
import AdminLoginPage from '../pages/admin/login/page';
import AdminRegisterPage from '../pages/admin/register/page';
import AdminArticlesPage from '../pages/admin/articles/page';
import ArticleEditPage from '../pages/admin/articles/edit/page';
import AdminNotesPage from '../pages/admin/notes/page';
import NoteEditPage from '../pages/admin/notes/edit/page';

// Lazy load components
const AdminPortfolioPage = lazy(() => import('../pages/admin/portfolio/page'));
const AdminPortfolioEditPage = lazy(() => import('../pages/admin/portfolio/edit/page'));
const AdminProgressPage = lazy(() => import('../pages/admin/progress/page'));
const AdminHomeContentPage = lazy(() => import('../pages/admin/home-content/page'));
const AdminUsersPage = lazy(() => import('../pages/admin/users/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/articles',
    element: <Articles />,
  },
  {
    path: '/articles/:id',
    element: <ArticleDetail />,
  },
  {
    path: '/notes',
    element: <Notes />,
  },
  {
    path: '/notes/:id',
    element: <NoteDetail />,
  },
  {
    path: '/portfolio',
    element: <Portfolio />,
  },
  {
    path: '/progress',
    element: <Progress />,
  },
  // Admin routes - public
  {
    path: '/admin/login',
    element: <AdminLogin />,
  },
  {
    path: '/admin/register',
    element: <AdminRegister />,
  },
  // Admin routes - protected
  {
    path: '/admin',
    element: <ProtectedRoute><AdminLayout /></ProtectedRoute>,
    children: [
      {
        path: 'dashboard',
        element: <AdminDashboardPage />,
      },
      {
        path: 'articles',
        element: <AdminArticlesPage />,
      },
      {
        path: 'articles/new',
        element: <ArticleEditPage />,
      },
      {
        path: 'articles/edit/:id',
        element: <ArticleEditPage />,
      },
      {
        path: 'notes',
        element: <AdminNotesPage />,
      },
      {
        path: 'notes/new',
        element: <NoteEditPage />,
      },
      {
        path: 'notes/edit/:id',
        element: <NoteEditPage />,
      },
      {
        path: 'portfolio',
        element: <AdminPortfolioPage />,
      },
      {
        path: 'portfolio/edit',
        element: <AdminPortfolioEditPage />,
      },
      {
        path: 'progress',
        element: <AdminProgressPage />,
      },
      {
        path: 'home-content',
        element: <AdminHomeContentPage />,
      },
      {
        path: 'users',
        element: <AdminUsersPage />,
      },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;